import React from "react";
import SchoolIcon      from "@mui/icons-material/SchoolOutlined";
import PeopleIcon      from "@mui/icons-material/PeopleOutline";
import CampaignIcon    from "@mui/icons-material/CampaignOutlined";
import PaymentIcon     from "@mui/icons-material/PaymentOutlined";
import FeedbackIcon    from "@mui/icons-material/FeedbackOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";

const sidebarConfig = () => [
  // First, because it is the way in to everything else: one search across every
  // organisation. The entries below are per-area lists that assume you already
  // know which area you want.
  {
    id:          "console",
    title:       "Console",
    description: "Search across every organisation",
    path:        "/console",
    icon:        <TravelExploreIcon />,
  },
  {
    id:          "flight-schools",
    title:       "Flight Schools",
    description: "Manage partner schools",
    path:        "/flight-schools",
    icon:        <SchoolIcon />,
  },
  {
    id:          "careers",
    title:       "Careers",
    description: "Job postings & applications",
    path:        "/careers/applications",
    icon:        <WorkOutlineIcon />,
  },
  {
    id:          "members",
    title:       "Members",
    description: "Platform users",
    path:        "/members",
    icon:        <PeopleIcon />,
  },
  {
    id:          "payments",
    title:       "Payments",
    description: "Revenue & transactions",
    path:        "/payments",
    icon:        <PaymentIcon />,
  },
  {
    id:          "feedback",
    title:       "Feedback",
    description: "User feedback & reviews",
    path:        "/feedback",
    icon:        <FeedbackIcon />,
  },
  {
    id:          "marketing",
    title:       "Marketing",
    description: "Acquisition & funnel analytics",
    path:        "/marketing",
    icon:        <CampaignIcon />,
  },
];

export default sidebarConfig;
